/* this file is transformed by vux-loader */
/* eslint-disable */
var state = {
  loading: 0,
  // 加载状态
  invalidResponse: {} // 异常响应

};
export default state;